import { scopedApi } from '@/session/scopedClients';
import type { RequestScope } from '@/session/scopedTransport';
import type { ApiQueryParams } from '@/types/apiQuery';
import { DBRecurringExport, DBExportType } from '@/types/export';
import { EndpointResponse } from '@/types/endpoints';
import { utils } from '../../utils';
import type { ReadRequestOptions } from '../requestOptions';

type RequestParams = Pick<ApiQueryParams, 'limit' | 'page'> & {
  exportType?: DBExportType;
};

type Response = DBRecurringExport[];

export const getRecurringExports = async (
  scope: RequestScope,
  { exportType, limit = 20, page = 1 }: RequestParams = {},
  options: ReadRequestOptions
): Promise<EndpointResponse<Response>> => {
  try {
    const result = await scopedApi(scope).get<EndpointResponse<Response>>('/recurring_export', {
      ...options,
      params: {
        sort: 'created_at:-1',
        limit,
        page,
        ...(exportType ? { query: { export_type: exportType } } : {}),
      },
    });

    return result.data;
  } catch (e) {
    return utils.error.handleAxiosError(e);
  }
};
